import * as getters from '@/store/modules/transfers/requests/nacional/naHoraSent/getters'
import * as mutations from '@/store/modules/transfers/requests/nacional/naHoraSent/mutations'
import * as actions from '@/store/modules/transfers/requests/nacional/naHoraSent/actions'

const state = {
  transfersRequestsStatusList: [],
  transfersSentRequestsList: [],
  transfersSentRequestsHasMore: false
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
